import { render, staticRenderFns } from "./modalRejectSuccessfulIndividual.vue?vue&type=template&id=2a35e05b&scoped=true&"
import script from "./modalRejectSuccessfulIndividual.vue?vue&type=script&lang=js&"
export * from "./modalRejectSuccessfulIndividual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35e05b",
  null
  
)

export default component.exports